import React, { useState, useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './Products.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Banner from '../../components/Banner/Banner';
import productsbannerimg from '../../images/products/products_benner_2.png';
import Btn_category from '../../components/Products/Btn_category';
import ProductCard from '../../components/Products/ProductCard';
import productData from '../../data/productData';
import { imageData } from './ProductsImg';
import { useLocation } from 'react-router-dom';
import AOS from 'aos';

const Products = () => {
  const [activeCategory, setActiveCategory] = useState('DRONE');
  const [showAll, setShowAll] = useState(false);
  const hasScrolled = useRef(false);
  const currentImages = imageData[activeCategory] || [];
  const visibleImages = showAll ? currentImages : currentImages.slice(0, 6);
  const { t } = useTranslation('products'); // Products namespace 사용
  const location = useLocation();

  // ✅ 렌더 전에 바로 hash 위치로 이동 (맨밑찍기 방지)
  useLayoutEffect(() => {
    const scrollToHash = () => {
      if (location.hash && !hasScrolled.current) {
        hasScrolled.current = true;
        const target = document.querySelector(location.hash);
        if (target) {
          requestAnimationFrame(() =>
            requestAnimationFrame(() => {
              target.scrollIntoView({ behavior: 'auto', block: 'start' });
              if (AOS && typeof AOS.refresh === 'function') AOS.refresh();
            })
          );
        }
      } else {
        window.scrollTo(0, 0);
      }
    };
    scrollToHash();
  }, [location]);

  return (
    <>
      <Header />
      <div className="Header_Block"></div>
      <div className="Container">
        <div className="Products_Banner">
          <Banner src={productsbannerimg} alt="Products 배너" aspect="21 / 9" />
        </div>
        <div id="hardware" className="container">
          <div className="Products_section1">
            <div className="Products_section_title">
              <div>Hardware</div>
            </div>
            <div className="Products_section1_description">{t('section1.des')}</div>
            <div className="Products_section1_items">
              {/* 버튼 클릭 시 카테고리 변경 */}
              <div className="Products_section1_items_category">
                <Btn_category onCategoryChange={setActiveCategory} />
              </div>

              {/* 이미지 박스 */}
              <div className="Products_section1_items_categoryBox">
                <div className="image-grid">
                  {visibleImages.map((item, idx) => (
                    <div className="image-card" key={idx}>
                      <img src={item.src} alt={item.name} />
                      <div>{item.name}</div>
                      {/* <p>{item.description}</p> */}
                      {/* <h href={item.link} target="_blank" rel="noopener noreferrer">
                자세히 보기
              </h> */}
                    </div>
                  ))}
                </div>

                {/* More 버튼 */}
                {currentImages.length > 6 && !showAll && (
                  <div className="more-btn-wrapper">
                    <button onClick={() => setShowAll(true)}>More</button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="background_white">
          <div id="software" className="container">
            <div className="Products_section2">
              <div className="Products_section_title">
                <div>Software</div>
              </div>
              <div className="Products_section2_description">{t('section2.des')}</div>
            </div>
          </div>
          <div className="Products_section2_items">
            <div>
              {productData.map((product) => (
                <ProductCard
                  key={product.id}
                  image={product.image}
                  alt={product.alt}
                  title={product.title}
                  descriptionKey={product.descriptionKey}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Products;
